import {
  useEffect,
  useState,
} from 'react';

export default function useSidebar({ defaultFile }) {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (defaultFile) {
      setOpenSidebar(true);
    }
  }, [defaultFile]);

  const handleSidebarToggle = (index, flag = false) => {
    setTabIndex(index);
    setOpenSidebar(flag);
  };

  return {
    openSidebar,
    tabIndex,
    setOpenSidebar,
    setTabIndex,
    handleSidebarToggle,
  };
}
